import React from 'react'
import { Flex, Text, Link, Box } from '@theme-ui/components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faMapMarkerAlt, faEnvelope } from '@fortawesome/free-solid-svg-icons'

export default function ContactDetails({ address, phone, email, alternativeGoogleMapLink }) {
  const { name, street, city, state, zip } = address || {}
  const googleString = address ? `https://www.google.com/maps?q=${name}+${street}+${city}+${state}+${zip}` : ''

  return (
    <Flex variant="contactDetails.container" className="contactDetails-container">
      {address ? (
        <Text variant="contactDetails.text" className="text address">
          <Link
            href={alternativeGoogleMapLink ? alternativeGoogleMapLink : googleString}
            target="_blank"
            rel="noreferrer"
          >
            <Flex>
              <FontAwesomeIcon icon={faMapMarkerAlt} />
              <Box sx={{ ml: '0.5rem' }}>
                {`${street}`}, {`${city}, ${state}, ${zip}`}
              </Box>
            </Flex>
          </Link>
        </Text>
      ) : (
        ''
      )}
      <Text variant="contactDetails.text" className="text phone">
        <Link href={`tel:${phone}`} target="_blank" rel="noreferrer">
          <FontAwesomeIcon icon={faPhone} /> {phone}
        </Link>
      </Text>
      {email ? (
        <Text variant="contactDetails.text" className="text email">
          <FontAwesomeIcon icon={faEnvelope} /> {email}
        </Text>
      ) : (
        ''
      )}
    </Flex>
  )
}

// component takes an address and phone
